// extracted by mini-css-extract-plugin
export default {"mDiv":"Portfolio_mDiv__yLr36","pDiv":"Portfolio_pDiv__OtnHt","PinpDiv":"Portfolio_PinpDiv__x7q3I","searchInp":"Portfolio_searchInp__CcjjV"};